import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { Grid, TextField, FormHelperText } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'
import { IOffer } from '../../../models/offers'

interface OffersModalGeneralInfoProps {
  offerState: IOffer
  setOfferState: Dispatch<SetStateAction<IOffer>>
  errorForm: any
  msgForm: any
}

const OffersModalGeneralInfo = ({ offerState, setOfferState, errorForm, msgForm }: OffersModalGeneralInfoProps) => {
  const { t } = useTranslation(['global'])
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  const handleInputChange = (inputName: string) => (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setOfferState({ ...offerState, [inputName]: value })
  }

  const handleAutoCompleteChange = (inputName: string) => async (_event: any, value: any) => {
    setOfferState({ ...offerState, [inputName]: value })
  }

  return (
    <Grid container direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
      <Grid item xs={12} md={offerState.brand != null ? 6 : 8}>
        <TextField
          label={t('title')}
          fullWidth
          required
          variant="filled"
          margin="normal"
          value={offerState.title}
          error={errorForm.title}
          helperText={msgForm.title}
          onChange={handleInputChange('title')}
        />
      </Grid>

      <Grid item xs={12} sm={offerState.brand != null ? 6 : 12} md={offerState.brand != null ? 3 : 4}>
        <Autocomplete
          id="combo-box-brands"
          value={offerState.brand}
          onChange={handleAutoCompleteChange('brand')}
          options={userBrands}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => (
            <TextField
              required
              {...params}
              label={t('brand')}
              error={errorForm.brand}
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
        <FormHelperText error={errorForm.brand}>{msgForm.brand}</FormHelperText>
      </Grid>

      {offerState.brand != null && (
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="combo-box-lines"
            value={offerState.line}
            onChange={handleAutoCompleteChange('line')}
            options={offerState.brand.active_lines}
            getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
            renderInput={params => (
              <TextField {...params} label={t('lines')} variant="filled" InputLabelProps={{ shrink: true }} />
            )}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default OffersModalGeneralInfo
